import React, { Component } from "react";
import "./Series.scss";
import logo from "../../../assets/images/loader_bg.png";
import Strings from "../../config/Strings";
import LazyLoad from 'react-lazy-load';
import {LanguageBadge} from "../../global/language-badge/LanguageBadge";


class AllSeriesItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            series: this.props.series
        };
    }

    async componentDidMount() {
    }

    render() {
        const series = this.state.series;
        let coverUrl = logo;
        let coverClass = '';
        if (series.displayImageUrl) {
            coverUrl = series.displayImageUrl;
        } else if (series.seasons && series.seasons[0] && series.seasons[0].episodes && series.seasons[0].episodes[0]
                && series.seasons[0].episodes[0].displayImageUrl) {
            coverUrl = series.seasons[0].episodes[0].displayImageUrl;
            coverClass = 'rounded-circle';
        }
        let title = series.name;


        return (
            <a href={"/series/" + series.slug + "/" + series.id} style={{textDecoration: "none"}}>
                <div className="all-series-item-cover">
                    <div className="all-series-item-cover-background-container">
                        {series.ageRecommended && series.ageRecommended > -1 &&
                                <div className="cover-age-display" dangerouslySetInnerHTML={{__html:Strings.SEARCH_ITEM_AGE.replace("{0}", series.ageRecommended)}}/>
                        }
                    </div>
                    <div className="all-series-item-image">
                        <LanguageBadge language={series.language}/>
                        <LazyLoad height={200} offset={300}>
                            <img src={coverUrl} alt={"Titelbild von " + title} className={coverClass}/>
                        </LazyLoad>
                    </div>
                </div>
                <div className="all-series-item-text-container">
                    <div className="series-item-name" dangerouslySetInnerHTML={{__html:title}}/>
                </div>
            </a>
        );
    }

}

export default AllSeriesItem;
